import { KeysetGridSearchHttpResponse, KeysetPagingMeta, KeysetPagingResultMeta } from '../../keyset-paging/keyset-paging-meta';
import { GridDataResultCustom } from './grid-data.service';

/**
 * Maps a keyset search HTTP payload to the grid row shape consumed by list components ({@code keysetPaging} on the row).
 */
export function gridRowFromKeysetSearchResponse(
  resp: KeysetGridSearchHttpResponse,
  requestMeta: KeysetPagingMeta
): GridDataResultCustom
{
  const row: GridDataResultCustom = {
    data: resp.data ?? [],
    total: resp.total ?? 0,
    export: null
  };
  const keysetPaging: KeysetPagingResultMeta = {
    hasMore: resp.hasMore === true,
    hasPrevious: resp.hasPrevious === true,
    nextCursor: resp.nextCursor ?? null,
    previousCursor: resp.previousCursor ?? null,
    ...requestMeta
  };
  (row as GridDataResultCustom & { keysetPaging: KeysetPagingResultMeta }).keysetPaging = keysetPaging;
  return row;
}
